// import axiosIns from '../utils/axios'
import { service as axiosIns, serviceO } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

function getAppUser(key) {
    var user = localStorage.getItem('user')
    if(user) {
        try {
            return JSON.parse(user)[key]
        } catch(e) {
            console.log(e)
        }
    }
    return ''
}

/**
 * 登录接口
 * @param {*} data 
 */
export function login(data) {
    return axiosIns({
        // url: 'api/login',
        url: '/user/login/doctor/login',
        // url: 'doctorService/api/login',
        method: 'POST',
        data
    })
}

/**
 * goRegister
 * 注册
 * @param {*} data{
 * code* 短信验证码
 * codeAuthToken* 验证码token
 * openId 用户微信openId
 * password* 密码
 * phone* 手机号
 * staffCode 人员ID
 * } 
 */
export function goRegister(data) {
	return axiosIns({
		url: 'userController/register',
		method: 'POST',
		data,
		header: headerJson
	})
}

/**
 * 获取验证码图片
 */
export function getCodeImg(){
    return axiosIns({
        url: 'verificationCode/getVerificationCode',
        // url: 'verificationCode/getVerificationCode',
        method: 'GET'
    })
}

/**
 * getFastCode
 * 快速登录获取手机验证码
 * @param {*} data {
 * phone* 手机号
 * }
 */
export function getFastCode(data) {
    return serviceO({
        url: 'appUser/login/sendVerifyCode',
        method: 'GET',
        data
    })
}

/**
 * fastLogin
 * 手机验证码登录
 * @param {*} data {
 * code* 验证码
 * openId 用户微信openId
 * phone* 手机号
 * staffCode 人员ID
 * systemType* 端类型(0.安卓,1.IOS,2.小程序)
 * }
 */
export function fastLogin(data) {
    return serviceO({
        url: 'appUser/login/loginByVerifyCode',
        method: 'POST',
        data
    })
}

/**
 * getPhoneCode
 * 发送验证码
 * @param {*} data {
 * phone* 手机号码
 * type* 短信模板类型(注册0 修改登陆密码1 修改支付密码2 解绑手机3 绑定新手机4)
 * }
 */
export function getPhoneCode(data) {
	return axiosIns({
		url: 'doctor/sendCodeCurrency',
		method: 'GET',
        data
    })
}

/**
 * checkVerifyCode
 * 校验验证码
 * @param {*} data{
 * phone* 手机号码
 * code* 验证码
 * codeAuthToken* 验证码token 
 * }
 */
export function checkVerifyCode(data) {
	return axiosIns({
		url: 'userController/checkVerifyCode',
		method: 'GET',
		data,
		header: headerForm
	})
}

/**
 * resetPwd
 * 修改密码
 * @param {*} data {
 * code* 验证码
 * phone* 手机号码
 * codeAuthToken* 短信验证token
 * newPassword* 新密码
 * }
 */
export function resetPwd(data) {
	return axiosIns({
		url: 'userSettingApi/resetPwd',
		method: 'POST',
		data,
		header: headerForm
	})
}

/**
 * 更新用户信息
 * @param {*} data 
 */
export function updataMemberInfo(data) {
    return axiosIns({
        url: 'userController/updateMemberInfo',
        method: 'GET',
        data
    })
}

// /**
//  * 通过memberId获取会员信息
//  * @param {memberCode} data 
//  */
export function getPersonalInfoByMemberId(params){
    return axiosIns({
        url: 'memberinfo/member/memberInfoDetail',
        method: 'GET',
        params
    })
}

// export function getPersonalInfoByMemberId(data){
//     return axiosIns({
//         url: `userController/memberInfo/${data.memberCode}`,
//         method: 'GET'
//     })
// }


// WEBPACK FOOTER //
// ./src/api/user.js